import http from "../utils/request";
//
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

// export function test(params) {
//   return http.get(`${resquest}/getList.json`, params);
// }

// 修改用户绑定角色
export function updateBinging(data){
  return http.put(`/role/updateBinging`,data)
}

// 获取全部用户列表
export function userRoles(data){
  return http.get(`/role/user`,data)
}

// 新增角色
export function permissionRoles(data){
  return http.post(`/role/permission`,data)
}

// 删除角色
export function delRoles(data){
  return http.delete(`/role?roleIds=${data.roleIds}`,data)
}

// 修改角色
export function putRoles(data){
  return http.put(`/role/permission`,data)
}

// 获取角色管理列表
export function getRoles(data){
  return http.get(`/role`,data)
}

// 新增路径
export function postPermission(data){
  return http.post(`/permission`,data)
}

// 修改路径名称
export function putPermission(data){
  return http.put(`/permission`,data)
}

// 获取所有页面路径
export function getPermission(data){
  return http.get(`/permission`,data)
}

// 获取模板信息
export function detailTemplate(data){
  return http.get(`/template/detail/${data.id}`,data)
}

// 获取项目下模板信息
export function infoTemplate(data){
  return http.get(`/template/info/${data.id}`,data)
}

// 删除超声模板
export function deleteTemplate(data){
  return http.delete(`/template/delete/${data.id}`,data)
}


// 修改超声模板
export function updateTemplate(data){
  return http.put(`/template/update`,data)
}

// 新增超声模板
export function addTemplate(data){
  return http.post(`/template/add`,data)
}

// 获取全部模板
export function templateList(data){
  return http.get(`/template/list`,data)
}

// 获取用户详情
export function userDel(data){
  return http.get(`/user/detail/`+data.id,data)
}

export function riskAnalyze(data){
  return http.get(`/result/riskAnalyze`,data)
}

export function setting(data){
  return http.get(`appointment/setting/${data.adminId}`,data)
}


export function uploadReport(data){
  return http.post(`result/updateResult/`,data)
}

export function deleteResult(data){
  return http.get(`result/delete/${data}`)
}

export function getAdminPlace(data){
  return http.get(`place/adminPlace`,data)
}
// 上传blob文件
export function uploadBlob(data){
  return http.post(`upload/blob`,data)
}
// 下载blob文件
export function downloadBlob(data){
  return http.post(`download/blob`,data)
}
export function getCoupon(data){
  return http.get(`coupon/checkCoupon`,data)
}

export function getActivation(data){
  return http.get(`home/code/${data.code}?activation=${data.activation}`)
}

// 获取全部套餐

export function getAllCombo(data){
  return http.get(`combo/getAll`,data)
}
// 查询所有上门预约
export function vipOrderFind(data) {
  return http.get(`home/visit/find`, data);
}

export function vipCheckOrder(data) {
  return http.post(`visit/checkOrder`, data);
}

export function updateVipAppointment(data) {
  return http.post(`/visit/update`, data);
}

export function vipOrder(data) {
  return http.post(`/visit/appointment`, data);
}

export function delproject(data) {
  return http.get(`/project/delete`, data);
}

export function placeSearchProject(data) {
  return http.get(`place/getProject`, data);
}

// 新增项目
export function projectAdd(data) {
  return http.post(`/project/add`, data);
}
// 修改项目
export function projectUpdate(data) {
  return http.post(`/project/update`, data);
}

// 查询全部项目列表
export function projectFind(data) {
  return http.get(`/project/getAll`, data);
}
// 保存订单
export function savePayOrder(data) {
  return http.post(`/wx/payOrder`, data);
}
// 获取视频
export function getVideoDetails(data) {
  return http.post(`/wx/payOrder`, data);
}

export function getDoctor(data) {
  return http.get(`/doctor/detail`, data);
}
export function getPay(data) {
  return http.get(`/wx/pay`, data);
}
// 获取openId
export function getOpenId(data) {
  return http.get(`/wx/getOpenid`, data);
}
// 查询全部注册码
export function getAllCode(data) {
  return http.get(`/adminCode/getAllCode`, data);
}

// 删除注册码
export function delCode(data) {
  return http.get(`/adminCode/deleteCode`, data);
}

// 修改注册码可使用次数
export function updateCode(data) {
  return http.post(`/adminCode/updateCode`, data);
}

// 申请预约
export function getAppointment(data) {
  return http.post(`/appointment`, data);
}
// 生成注册码
export function getCode(data) {
  return http.post(`adminCode/insert`, data);
}
// 用户修改密码
export function updatePassword(data) {
  return http.post(`admin/updatePwd`, data);
}
// 修改预约状态
export function updateAppointment(data) {
  return http.get(`/appointment/update`, data);
}
// 查询所有预约
export function searchAllOrder(data) {
  return http.get(`appointment/getAll`, data);
}

// 查询所有报告
export function searchAppointment(data) {
  return http.get(`result/getByPlace`, data);
}
// 查询当前时间点预约人数
export function checkAppointment(data) {
  return http.get(`/appointment/number`, data);
}
// 查询检测结果
export function submitForm(data) {
  return http.get(`/result/getUserResultList`, data);ff
}

// 查询检测详情
export function getDetails(data) {
  return http.get(`/result/getDetail/${data.id}`,data);
}

// 查询我的预约
export function searchMyorder(data) {
  return http.get(`/appointment`, data);
}

// 查询是否有预约
export function searchOffMyorder(data) {
  return http.post(`/appointment/checkMyOrder`, data);
}

// 删除地址
export function delAddress(id) {
  return http.get(`/place/${id}`);
}

// 新增地址
export function insertAddress(data) {
  return http.post(`/place/insert`, data);
}

// 搜索地址
export function searchAddress(data) {
  return http.get(`/place/getList`, data);
}

// 获取全部地址
export function selectAlltAddress(data) {
  return http.get(`place/getList`, data);
}

// 修改地址
export function updatetAddress(data) {
  return http.post(`/place/update`, data);
}
// 修改地址
export function updatetAddressProjects(data) {
  return http.post(`/place/updatePlaceProject`, data);
}


